import { useEffect } from 'react'
import PubSub from '@paytrace/pt-skel/Event/PubSub'
import Event from '../Event'
import { clearNetworkError, raiseNetworkError } from '../Helper/util'

/**
 * Intercepts global Event.NETWORK_ERROR messages and replaces them with a custom string.
 * Uses a deferred event loop tick to bypass parent PubSub listener order.
 */
export function useNetworkErrorInterceptor (customMessage: string) {
  useEffect(() => {
    const interceptorSymbol = Symbol('NetworkErrorInterceptor')

    PubSub.sub(interceptorSymbol, Event.NETWORK_ERROR, (rawError: any) => {
      // 1. Prevent infinite loops when receiving our own custom message
      if (rawError?.message === customMessage || rawError === customMessage) {
        return
      }

      // 2. Defer execution to the next tick so parent NetErrorFeedback processes first
      setTimeout(() => {
        clearNetworkError()
        raiseNetworkError(customMessage)
      }, 0)
    })

    return () => {
      PubSub.unsub(interceptorSymbol)
    }
  }, [customMessage])
}
